import Target from 'dashboard/components/GraphCanvasV2/target/target';
import { CollapsedPairwiseNode } from 'dashboard/models/graph';

export default class CollapsedPairwiseNodeTarget extends Target<CollapsedPairwiseNode> {
  type = 'collapsed-pairwise-node';
}
